import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PriceBlock } from './PriceBlock';
import { TrustStrip } from './TrustStrip';
import { BRAND, HERO_BODY, HERO_HEADLINE_BOTTOM, HERO_HEADLINE_TOP, HERO_KICKER, HERO_LABEL_SUB, HERO_SUB, MAIN_MOCKUP, MOBILE_CTA_LABEL, MOBILE_HERO_BUNDLE, MOBILE_HERO_HEADLINE_BOTTOM, MOBILE_HERO_HEADLINE_TOP, MOBILE_HERO_KICKER, MOBILE_HERO_SUB, MOCKUP_ALT, PRODUCT, heroBenefits, heroFlow, mobileTrust, pricing } from '../data/poolContent';
export function Hero() {
  return <header className="w-full bg-abyss-950" data-id="element-154" data-mp="sb1e1x0sed9q">
      <div className="mx-auto hidden max-w-6xl items-center justify-between px-5 pt-5 lg:flex" data-id="element-155" data-mp="s9q8psrp0xgi">
        <p className="font-display text-base font-bold tracking-[0.2em] text-frost-50 lg:text-lg" data-id="element-156" data-mp="nboov5mg0u3z">
          {BRAND}
        </p>
        <p className="hidden text-[10px] font-medium uppercase tracking-[0.16em] text-muted sm:block" data-id="element-157" data-mp="3cz5uuafyvxzt">
          100% Digital · Instant Access
        </p>
      </div>

      {/* Mobile / tablet: problem → promise → product → price → buy */}
      <div className="mx-auto w-full max-w-xl px-4 pb-6 pt-4 text-center lg:hidden" data-id="element-158" data-mp="3o7vllomspvze">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-aqua" data-id="element-159" data-mp="39auqrc9b5kwp">
          {MOBILE_HERO_KICKER}
        </p>
        <h1 className="mt-1.5 font-display text-[2.3rem] font-bold uppercase leading-[0.95] text-frost-50 min-[375px]:text-[2.6rem] sm:text-[3rem]" data-id="element-160" data-mp="3e84nlcz10yuk">
          {MOBILE_HERO_HEADLINE_TOP}
          <span className="block text-pool-light" data-id="element-161" data-mp="359t19n570n7x">{MOBILE_HERO_HEADLINE_BOTTOM}</span>
        </h1>
        <p className="mx-auto mt-2 max-w-sm text-[14px] leading-snug text-frost-100" data-id="element-162" data-mp="2qkmune40zuq0">
          {MOBILE_HERO_SUB}
        </p>

        <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto mt-3 block h-auto w-[60%] max-w-[15.5rem] object-contain" width={1199} height={1312} data-id="element-163" data-mp="2vjg48vg6z1kw" />

        <p className="mt-2 flex items-baseline justify-center gap-2" data-id="element-164" data-mp="2lmv0sejtlyj6">
          <span className="font-display text-[2.6rem] font-bold leading-none text-frost-50" data-id="element-165" data-mp="s2tffr2zujsd">
            {pricing.today}
          </span>
          <span className="text-xs font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-166" data-mp="n9i53fyz3kvp">USD</span>
        </p>

        <div className="mt-2.5 flex justify-center" data-id="element-167" data-mp="dd5dqoqwhj44">
          <CtaButton size="lg" label={MOBILE_CTA_LABEL} data-id="element-168" data-mp="degiaqs66uwa" />
        </div>

        {/* Supporting details — below the first CTA */}
        <p className="mt-4 text-[12px] font-semibold uppercase tracking-[0.14em] text-frost-200" data-id="element-169" data-mp="1ayt5uxgbpf9u">
          {MOBILE_HERO_BUNDLE}
        </p>
        <ul className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[10.5px] font-medium uppercase tracking-[0.1em] text-muted" data-id="element-170" data-mp="111ycesywq52f">
          {mobileTrust.map(t => <li key={t} className="flex items-center gap-1 whitespace-nowrap" data-id="element-171" data-mp="3ltgndrclksov">
              <CheckIcon className="h-3 w-3 text-aqua" strokeWidth={3} aria-hidden="true" data-id="element-172" data-mp="3hrdacyaa5g1h" />
              {t}
            </li>)}
        </ul>
      </div>

      {/* Desktop */}
      <div className="mx-auto hidden max-w-6xl grid-cols-[1.05fr_1fr] grid-rows-[auto_auto] items-center gap-x-12 px-5 pb-16 pt-10 text-left lg:grid" data-id="element-173" data-mp="1x7hv3bmtnyzt">
        <div className="col-start-1 row-start-1 self-end" data-id="element-174" data-mp="268y69llgo553">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-aqua" data-id="element-175" data-mp="2b0pon8ugr4k5">
            {HERO_KICKER}
          </p>
          <h1 className="mt-4 max-w-xl font-display text-[3.9rem] font-bold uppercase leading-[0.95] text-frost-50" data-id="element-176" data-mp="2g0lpx0bs0hw0">
            {HERO_HEADLINE_TOP}
            <span className="mt-1 block text-pool-light" data-id="element-177" data-mp="2l1012r8oc7y9">{HERO_HEADLINE_BOTTOM}</span>
          </h1>

          <p className="mt-5 max-w-lg text-[15px] font-medium leading-relaxed text-frost-100" data-id="element-178" data-mp="2oyebgm83clru">
            {HERO_SUB}
          </p>
          <p className="mt-3 max-w-lg text-[14.5px] leading-relaxed text-body" data-id="element-179" data-mp="umzhtubym26t">{HERO_BODY}</p>

          <ol className="mt-5 flex flex-wrap items-center gap-x-2.5 gap-y-1.5" aria-label="How the guide works" data-id="element-180" data-mp="zlapbyes80lv">
            {heroFlow.map((step, i) => <li key={step} className="flex items-center gap-2.5" data-id="element-181" data-mp="49jdg5ykopmn" data-mpi={i}>
                <span className="text-[12px] font-semibold uppercase tracking-[0.12em] text-aqua" data-id="element-182" data-mp="3vgniivb5q1sf">
                  {step}
                </span>
                {i < heroFlow.length - 1 && <span className="text-pool/60" aria-hidden="true" data-id="element-183" data-mp="9bigtfubbmjl">
                    →
                  </span>}
              </li>)}
          </ol>
        </div>

        <figure className="col-start-2 row-span-2 row-start-1 w-full" data-id="element-184" data-mp="3crz0ch426akc">
          <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="w-full object-contain" width={1199} height={1312} data-id="element-185" data-mp="3rg3nbxa5988x" />
          <figcaption className="mt-3 text-center" data-id="element-186" data-mp="3motxavkoo2wi">
            <span className="block font-display text-xl font-bold uppercase tracking-[0.06em] text-frost-50" data-id="element-187" data-mp="3mo2d0gwjdrlj">
              {PRODUCT}
            </span>
            <span className="mt-0.5 block text-[11px] font-medium uppercase tracking-[0.14em] text-muted" data-id="element-188" data-mp="2u1hlngg29fhz">
              {HERO_LABEL_SUB}
            </span>
          </figcaption>
        </figure>

        <div className="col-start-1 row-start-2 self-start" data-id="element-189" data-mp="1e9vvx8pt2wi2">
          <ul className="mt-7 grid max-w-lg grid-cols-2 gap-x-5 gap-y-2" data-id="element-190" data-mp="1eb6xd1vs3s60">
            {heroBenefits.map(b => <li key={b} className="flex items-start gap-2" data-id="element-191" data-mp="14jkfimoxquua">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-aqua" strokeWidth={2.5} aria-hidden="true" data-id="element-192" data-mp="14ju5ia9zd1zz" />
                <span className="text-[13.5px] leading-snug text-frost-100" data-id="element-193" data-mp="1s728gljxryyu">{b}</span>
              </li>)}
          </ul>

          <PriceBlock align="start" size="md" className="mt-7" data-id="element-194" data-mp="1j8qjsp2mrb91" />

          <div className="mt-5 flex justify-start" data-id="element-195" data-mp="1jajhvfz6gn5f">
            <CtaButton size="lg" data-id="element-196" data-mp="1n9agjrjakcun" />
          </div>
          <TrustStrip variant="full" className="mt-4 justify-start" data-id="element-197" data-mp="1nbwq1wpqt2fi" />
        </div>
      </div>
    </header>;
}